import { Header, Footer } from '@/components/layout'
import { Features } from '@/components/sections'
import { SEO } from '@/components/seo'

export default function FeaturesPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Features"
        description="Explore Ledger's features: income and expense tracking, customer credit management, receipt capture, financial reports, and cloud backup — all from your phone."
        canonical="/features"
      />
      <Header />
      <main className="pt-16">
        <Features />
      </main>
      <Footer />
    </div>
  )
}
